export default __webpack_public_path__ + "static/media/STD2.a716d551.png";